<template>
    <span class="badge" :class="classes">{{ statusText }}</span>
</template>

<script>

  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {string}
       */
      statusText() {
        return _.get(this, 'row.model.status_text');
      },

      /**
       * @return {number|null}
       */
      status() {
        return _.get(this, 'row.model.status');
      },

      /**
       * @return {object}
       */
      classes() {
        const map = {
          1: 'badge-grey',  // ACTIVE
          2: 'badge-secondary',  // INACTIVE
        };

        return  {[_.get(map, this.status, 'badge-secondary')]: true};
      },
    }
  }
</script>

